export default __webpack_public_path__ + "static/media/placeholder-light-poster.ff46139d.jpg";